import _ from 'lodash';
import moment from 'moment';

import Rest from 'services/data/rest';

export default class Timer extends Rest {
  static path = 'timer';
  static defaultQuery = {
    load: [
      'ticket.agreement.rates',
      'company',
      'createdBy',
      'timerIntervals'
    ]
  };

  static isActive(timer) {
    return _.some(timer.timerIntervals, interval => !_.get(interval, 'end'));
  }

  static hasTime(timer) {
    return _.get(timer, 'timerIntervals.length');
  }

  static anyActive(timers) {
    return _.some(timers, Timer.isActive);
  }

  static anyUnstarted(timers) {
    return _.some(timers, ['timerIntervals.length', 0]);
  }

  static getDuration(timer) {
    const milliseconds = _.reduce(timer.timerIntervals, (total, interval) =>
      total + moment(interval.end || undefined).diff(interval.start)
    , 0);

    return moment.duration(milliseconds);
  }
}
